import * as React from 'react';
import { useEffect, useState } from 'react';

import { classNames } from 'uitk-react-utils';

import { useStores } from 'hooks';

import { getInstanceFromUrl, sendResizeMessage } from 'modules/resize-message';

import { getLayoutStyle, Image, Link, Panel, useBannersContext } from 'features/banners';

type BannerQueries = {
  instance?: string;
  message?: string;
  action?: string;
  layout?: string;
  image?: string;
  link?: string;
  network?: string;
};

function Banner(): JSX.Element {
  const {
    app: { routeQueries },
  } = useStores();
  const { layoutId, setAction, setMessage, setLayout, setImage, setLink } = useBannersContext();

  const [bannerClassName, setBannerClassName] = useState('banner');

  useEffect(() => {
    const queries: BannerQueries = routeQueries;
    setLayout(queries.layout);
    setImage(queries.image);
    setMessage(queries.message);
    setAction(queries.action);
    setLink(queries.link);
  }, [routeQueries]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (layoutId) {
      // Read instance from the live iframe URL, not the hydrated store, so the
      // SSR response stays cacheable across loads (see getInstanceFromUrl).
      const instance = getInstanceFromUrl();
      const layoutStyle = getLayoutStyle({ layoutId });
      sendResizeMessage({
        type: 'eg-affiliate-banners/resize',
        meta: { instance },
        payload: {
          frame: { style: layoutStyle },
        },
      });

      const nextBannerClassName = classNames('banner', `banner--${layoutId}`);
      setBannerClassName(nextBannerClassName);
    }
  }, [layoutId]);

  return (
    <article className={bannerClassName}>
      {layoutId && (
        <Link>
          <Image />
          <Panel />
        </Link>
      )}
    </article>
  );
}

export { Banner };
